import Component from '@bythepixel/component-loader';

const selectors = {
  modalContainer: '.modal__container',
  modalContent: '.modal__content',
  modalHeader: '.modal__header',
};

export default class SectionProductSpecs extends Component {
  static selector = '[data-comp-section-product-specs]';

  constructor(containerEl) {
    super(containerEl);
    this.specsModal = containerEl.querySelector('#specs-amenities-modal');

    this.modalContainer = this.specsModal.querySelector(selectors.modalContainer);
    this.modalContent = this.specsModal.querySelector(selectors.modalContent);
    this.modalHeader = this.specsModal.querySelector(selectors.modalHeader);

    this.initializeEvents();
  }

  initializeEvents() {
    this.modalContainer.addEventListener('scroll', () => {
      this.toggleModalNavDropShadow();
    });
  }

  toggleModalNavDropShadow() {
    if (!this.initialTop) {
      this.initialTop = this.modalContent.getBoundingClientRect().top;
    }

    if (this.modalContent.getBoundingClientRect().top < (this.initialTop - 15)) {
      this.modalHeader.classList.add('modal__header--shadow');
    } else {
      this.modalHeader.classList.remove('modal__header--shadow');
    }
  }
}
